// extracted by mini-css-extract-plugin
module.exports = {"table":"skillsDialog_table__3J4Z0","tips":"skillsDialog_tips__1o5MM","formslayout":"skillsDialog_formslayout__1R5Vq"};